import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { ProviderListParams } from '@/lib/api/domains/providers';
import type { ProviderId } from '@/lib/api/ids';
import { keys } from '@/lib/query-keys';

/** Consumption layer for providers (mirrors clients'/invoices' shape). */
export function providerListQuery(params: ProviderListParams) {
  return queryOptions({
    queryKey: keys.providers.list(params),
    queryFn: () => api.providers.list(params),
    staleTime: 30_000,
  });
}

export function providerDetailQuery(providerId: ProviderId) {
  return queryOptions({
    queryKey: keys.providers.detail(providerId),
    queryFn: () => api.providers.get(providerId),
    staleTime: 30_000,
  });
}
